import en from './en/common';
import vi from './vi/common';
import zh from './zh/common';
import ja from './ja/common';
import ko from './ko/common';
import es from './es/common';
import fr from './fr/common';

const messages = {
  en: {
    common: en,
  },
  vi: {
    common: vi,
  },
  zh: {
    common: zh,
  },
  ja: {
    common: ja,
  },
  ko: {
    common: ko,
  },
  es: {
    common: es,
  },
  fr: {
    common: fr,
  },
};

export default messages;
